import React from 'react';

const Contact = () => {
  return (
    <div className="contact">
      <a href="https://www.github.com/TJahongir">
        <i className="fab fa-github" target="_blank"></i>
      </a>
      <a href="https://www.toshkhujaev.com">
        <i className="fas fa-mouse-pointer" target="_blank"></i>
      </a>
      <a href="https://www.github.com/TJahongir">
        <i className="fab fa-linkedin" target="_blank"></i>
      </a>
    </div>
  );
};
export default Contact;
